import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const SupportNewMessageIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 16 17" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M2 2.4a2 2 0 0 1 1.3-.6h4.5a.7.7 0 0 1 0 1.4H3.3a.7.7 0 0 0-.6.6v9l1.5-1.4c.1-.2.3-.2.5-.2h8a.7.7 0 0 0 .6-.7V8.7a.7.7 0 0 1 1.4 0v1.8a2 2 0 0 1-2 2H4.9L2.5 15a.7.7 0 0 1-1.2-.5V3.8c0-.5.2-1 .6-1.4Z"
        clipRule="evenodd"
      />
      <path d="M12 6.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
      <path
        fillRule="evenodd"
        d="M12 3.2a1.3 1.3 0 1 0 0 2.6 1.3 1.3 0 0 0 0-2.6ZM9.3 4.5a2.7 2.7 0 1 1 5.4 0 2.7 2.7 0 0 1-5.4 0Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default SupportNewMessageIcon;
